class WhoAreWeModel {
	firstTitle;
	firstDescription;
	secondTitle;
	secondDescription;
	image;


	constructor({
		firstTitle = '', firstDescription = '', secondTitle = '', secondDescription = '', image = '',
	}) {
		this.firstTitle = firstTitle;
		this.firstDescription = firstDescription;
		this.secondTitle = secondTitle;
		this.secondDescription = secondDescription;
		this.image = image;
	}
}

export default WhoAreWeModel;
